export default __webpack_public_path__ + "static/media/img_step_situation06.ad1b254b.jpg";